import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";
import logoSrc from "../../../components/logos/logo.svg";
import "./CashlessModal.scss";

const LOGO_HEIGHT = 44;

export function CashlessCardQrPreview({ cardId }) {
  const { t } = useTranslation("cashless");
  const qrRef = useRef(null);
  const normalizedCardId = String(cardId || "").trim().toUpperCase();

  if (!normalizedCardId) return null;

  const downloadPng = () => {
    const canvas = qrRef.current;
    if (!canvas) return;

    const padding = 42;
    const qrSize = canvas.width;
    const width = qrSize + padding * 2;
    const height = qrSize + LOGO_HEIGHT + padding * 3 + 46;
    const output = document.createElement("canvas");
    output.width = width;
    output.height = height;
    const context = output.getContext("2d");
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, width, height);

    const logo = new Image();
    logo.src = logoSrc;
    logo.onload = () => {
      const logoWidth = logo.width * (LOGO_HEIGHT / logo.height);
      context.drawImage(logo, (width - logoWidth) / 2, padding, logoWidth, LOGO_HEIGHT);
      context.fillStyle = "#0b1833";
      context.font = "bold 16px Arial";
      context.textAlign = "center";
      context.fillText(t("cashlessCard"), width / 2, padding + LOGO_HEIGHT + 22);
      context.drawImage(canvas, padding, padding + LOGO_HEIGHT + 38, qrSize, qrSize);
      context.font = "bold 13px monospace";
      context.fillText(normalizedCardId, width / 2, height - padding / 2);

      const link = document.createElement("a");
      link.href = output.toDataURL("image/png");
      link.download = `cashless-card-${normalizedCardId}.png`;
      link.click();
    };
  };

  return (
    <section className="cashless-card-qr-preview" aria-label={t("cashlessQrCode")}>
      <h6>{t("cashlessQrCode")}</h6>
      <p>{t("cashlessQrCodeDescription")}</p>
      <div className="cashless-card-qr-preview-code">
        <QRCodeCanvas value={normalizedCardId} size={176} ref={qrRef} />
      </div>
      <code>{normalizedCardId}</code>
      <button type="button" onClick={downloadPng} className="btn btn-outline-light">
        {t("downloadQrPng")}
      </button>
    </section>
  );
}

export default CashlessCardQrPreview;
